import { Component, OnInit, Input, Output, EventEmitter, forwardRef, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

import { SessionStorageService, PageContentService, CodedService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';
import { CodeValue } from '../../core/index.model';

@Component({
    selector: 'pnx-codeddropdownlist',
    templateUrl: './codeddropdownlist.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CodedDropDownControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CodedDropDownControl), multi: true }
    ]
})
export class CodedDropDownControl implements OnInit, ControlValueAccessor, Validator {

    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';

    @Input() pagecontent: PageContent;
    @Input() CodeID: number;
    @Input() CodedList: CodeValue[];
    @Output() Select: EventEmitter<CodeValue> = new EventEmitter<CodeValue>();

    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input() mandatory: boolean = false;
    @Input() readonly: boolean = false;
    @Input() codedcontainerstyle: string = 'row';
    @Input() codedctrlstyle: string = '';
    @Input() labelstyle: string = 'control-label';
    @Input('value') _value = '';
    @Input() cleartextondisable: boolean = false;
    @Input() control: FormControl;
    @Input() disable: boolean = false;

    @Input() DefaultJuris: boolean= false;

    disabled: boolean = false;
    Ddl: CodeValue[];
    SelectedValue: CodeValue;

    constructor(
        private fb: FormBuilder,
        private codedService: CodedService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService
    ) { }

    ngOnInit() {

        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }

        if (this.CodedList) {
            this.Ddl = this.CodedList;
        }
        else {
            this.getCodedList(this.CodeID);
        }
    }

    ngOnChanges(Changes: SimpleChanges) {
        if (Changes['CodedList']) {
            this.Ddl = this.CodedList;
        }

        if (Changes['disable']) {
            this.setDisabledState(Changes['disable'].currentValue);
        }
        
        this.propagateChange(this.value);
        if (this.control) {
            this.validate(this.control);
        }

        if (this.readonly) {
            this.CodedValue.disable();
        }

        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        let placeHolderValue = (this.placeholderId) ? this.pageContentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;

        if (this.CodedList) {
            this.Ddl = this.CodedList;
        }
        else {
            this.getCodedList(this.CodeID);
        }
    }

    onCodedChange(CValue: string) {
        let CodeValue: CodeValue = this.Ddl.find(x => x.CodeValue == CValue);
        this.value = this.CodedValue.value;
        this.SelectedValue = CodeValue;
        this.Select.emit(CodeValue);
    }

    getCoded(): CodeValue {
        this.CodedValue.markAsTouched();
        return this.SelectedValue;
    }

    bindCodedList(CodedList: CodeValue[]) {
        this.Ddl = CodedList;
    }

    getCodedList(CodeID: number) {
        if (CodeID==2080 && this.DefaultJuris) {
            this.codedService.GetCodedDropdownValues(this.storageService.getJurisNo().toString(), CodeID.toString())
                .then(codedList => {
                    this.bindCodedList(codedList);
                })
                .catch(err => { });
        }
        else if (CodeID && this.storageService.getJurisNo()) {
            this.codedService.GetCodedDropdownValues(this.storageService.getJurisNo().toString(), CodeID.toString())
                .then(codedList => {
                    if(CodeID == 1990){
                        sessionStorage.setItem('themeList', JSON.stringify(codedList))
                    }
                    this.bindCodedList(codedList);
                })
                .catch(err => { });
        }
    }

    CodedValue = new FormControl();

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value): void {
        this.value = value;
        this.CodedValue.setValue(this.value);
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn): void { }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (this.disabled && this.cleartextondisable) {
            this.value = '';
            this.CodedValue.setValue(this.value);
            this.CodedValue.disable();
        }
        else if (this.disabled) {
            this.CodedValue.disable();
        }
        else {
            this.CodedValue.enable();
        }

    }

    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.CodedValue.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.CodedValue.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        if (!parentControl.disabled && this.disable) {
            parentControl.disable();
        }

        return null;
    }
}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/codeddropdownlist.control.ts